<template>
  <div id="app">
    <input type="file" ref="fileInput" @change="handleImport" id="importFile" accept=".json" style="display: none;" >
    <VuePrint></VuePrint>
    <!-- <TestComponent></TestComponent> -->
    
  </div>
</template>

<script>
import VuePrint from "@/components/VuePrint";
import TestComponent from "@/components/TestComponent";
export default {
  name: "App",
  components: {
    VuePrint,
    TestComponent,
  },
  beforeMount() {
    this.$store.dispatch("init");
    this.$bus.$on("handleImportClick", () => {

      this.$refs.fileInput.click();
    });
  },
 
  methods: {
    handleImport(e) {
      const file = e.target.files[0];
      let importedData;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            // 解析 JSON 数据
            importedData = JSON.parse(e.target.result);
            this.$bus.$emit("handleImport", importedData);
            // 清空file
            this.$refs.fileInput.value = '';
 
          } catch (error) {
            console.error('解析文件时出错：', error);
          }
        };
        reader.readAsText(file);
      }
    }
  }

};
</script>


<style>
</style>
